module.exports = __webpack_public_path__ + "static/frontUserNew/img/typeppt.08988226.svg";